/**
 * Display name utilities for Korean UI rendering
 * Maps enum constants to Korean display names
 */
import type { Color, GamePhase, PieceType } from "../types/common";

const PIECE_TYPE_DISPLAY_NAMES: Record<PieceType, string> = {
  KING: "킹",
  QUEEN: "퀸",
  ROOK: "룩",
  BISHOP: "비숍",
  KNIGHT: "나이트",
  PAWN: "폰",
};

const COLOR_DISPLAY_NAMES: Record<Color, string> = {
  WHITE: "백",
  BLACK: "흑",
};

const GAME_PHASE_DISPLAY_NAMES: Record<GamePhase, string> = {
  CHECKMATE: "체크메이트",
  STALEMATE: "스테일메이트",
  DRAW: "무승부",
  PLAYING: "진행 중",
  AUGMENTATION_SELECTION: "증강 선택",
  CONSECUTIVE_CHECK_WIN: "연속 체크 승리",
};

export function getPieceTypeDisplayName(type: PieceType): string {
  return PIECE_TYPE_DISPLAY_NAMES[type];
}

export function getColorDisplayName(color: Color): string {
  return COLOR_DISPLAY_NAMES[color];
}

export function getGamePhaseDisplayName(phase: GamePhase): string {
  return GAME_PHASE_DISPLAY_NAMES[phase];
}
